import { flow } from 'lodash-es';

import type { ClauseDraft } from '../draft/types';

import { assembleLists } from './assemble-lists';
import { promoteHeadings } from './promote-headings';
import { quantiseIndents } from './quantise-indents';
import { quantiseSpacing } from './quantise-spacing';
import { resolveBodySize } from './resolve-body-size';
import { snapFontSizes } from './snap-font-sizes';
import { trimEdges } from './trim-edges';

export const runPasses: (draft: ClauseDraft) => ClauseDraft = flow(
  resolveBodySize,
  snapFontSizes,
  promoteHeadings,
  assembleLists,
  quantiseIndents,
  quantiseSpacing,
  trimEdges,
);
